/* eslint-disable */
export default {
  transform: (chunk, { Types, Promise, Mappers, Logger }) =>
    new Promise(resolve => {
      const salonMapper = Mappers('salon');
      const userMapper = Mappers('user');
      const distributorProductMapper = Mappers('distributorProduct');
      let distributorMongoId = null;
      const queryBuilderCache = {
        salons: {},
        reps: {},
        distProducts: {},
        masterProducts: {},
        masterProductBrands: {},
      };
      chunk.forEach(obj => {
        if (distributorMongoId == null) {
          distributorMongoId = new Types.ObjectId(obj.__tmp.dist_id);
        }
        queryBuilderCache.salons[obj.$set.ext_salon_id] = null;

        queryBuilderCache.reps[obj.$set.ext_rep_id] = {
          dist_ext_id: obj.$set.ext_rep_id,
        };

        queryBuilderCache.distProducts[obj.$set.ext_prod_id] = {
          ext_id: obj.$set.ext_prod_id,
        };
      });

      return Promise.map(Object.keys(queryBuilderCache.salons), ext_id => {
        return salonMapper
          .findOne({
            ref: {
              $elemMatch: {
                distributor: distributorMongoId,
                ext_id
              }
            }
          })
          .lean()
          .select('_id ref')
          .exec()
          .then(salon => {
            console.info({salon, ext_id});
            if (salon != null) {
              queryBuilderCache.salons[ext_id] = salon._id;
            } else {
              delete queryBuilderCache.salons[ext_id];
            }
          });
      }, {concurrency: 100})
        .then(results => {
          // console.info('queryBuilderCache.salons[ext_id]', queryBuilderCache.salons)
          // console.info('results', results);
          // then find all sales reps
          // reps query
          const repExtIDQueryFragment = Object.keys(queryBuilderCache.reps).map(
            key => queryBuilderCache.reps[key],
          );
          const repQuery = {
            $and: [
              { distributor: distributorMongoId },
              { $or: repExtIDQueryFragment },
            ],
          };
          return userMapper
            .find(repQuery)
            .lean()
            .select('distributor dist_ext_id')
            .exec();
        })
        .then(reps => {
          queryBuilderCache.reps = {};
          reps.forEach(rep => {
            queryBuilderCache.reps[rep.dist_ext_id] = rep._id;
          });
          // reps query
          const productExtIDQueryFragment = Object.keys(
            queryBuilderCache.distProducts,
          ).map(key => queryBuilderCache.distProducts[key]);
          const productQuery = {
            $and: [
              { distributor: distributorMongoId },
              { $or: productExtIDQueryFragment },
            ],
          };
          return distributorProductMapper
            .find(productQuery)
            .select('_id ext_id master_product brand')
            .populate('master_product')
            .lean()
            .exec();
        })
        .then(products => {
          queryBuilderCache.distProducts = {};
          products.forEach(product => {
            queryBuilderCache.distProducts[product.ext_id] = product._id;
            if (product.master_product != null) {
              queryBuilderCache.masterProducts[product.ext_id] = product.master_product._id;
              queryBuilderCache.masterProductBrands[product.ext_id] = product.master_product.brand;
            }
          });

          // Logger.info(queryBuilderCache);
          const salonBulkOps = [];
          const newChunk = chunk.map(obj => {
            const newObject = { ...obj };
            // console.info('salon newObject', newObject);
            if (!newObject.$set) {
              newObject.$set = {};
            }
            newObject.$set.distributor = new Types.ObjectId(
              newObject.__tmp.dist_id,
            );
            newObject.$set.dm = new Date();

            if (!newObject.$setOnInsert) {
              newObject.$setOnInsert = {};
            }
            newObject.$setOnInsert.e = true;
            newObject.$setOnInsert.dc = new Date();

            // __tmp is used to store temporary data we may need
            delete newObject.__tmp;

            const alerts = newObject.$set.alerts;
            // assign salon
            if (newObject.$set.ext_salon_id in queryBuilderCache.salons) {
              newObject.$set.salon =
                queryBuilderCache.salons[newObject.$set.ext_salon_id];
            } else {
              alerts.push({ code: 'salon-ext-id-invalid', level: 'warning' });
            }

            // assign distrobutor product
            if (newObject.$set.ext_prod_id in queryBuilderCache.distProducts) {
              newObject.$set.dist_prod =
                queryBuilderCache.distProducts[newObject.$set.ext_prod_id];
            } else {
              alerts.push({
                code: 'distributor-ext-id-invalid',
                level: 'warning',
              });
            }

            // assign master product
            if (
              newObject.$set.ext_prod_id in queryBuilderCache.masterProducts
            ) {
              newObject.$set.master_product =
                queryBuilderCache.masterProducts[newObject.$set.ext_prod_id];
            } else {
              alerts.push({
                code: 'master-product-idh-invalid',
                level: 'warning',
              });
            }

            // assign master product brand
            if (
              newObject.$set.ext_prod_id in queryBuilderCache.masterProductBrands
            ) {
              newObject.$set.brand =
                queryBuilderCache.masterProductBrands[newObject.$set.ext_prod_id];
            } else {
              alerts.push({
                code: 'master-product-brand-invalid',
                level: 'warning',
              });
            }

            // assign rep
            if (newObject.$set.ext_rep_id in queryBuilderCache.reps) {
              newObject.$set.user =
                queryBuilderCache.reps[newObject.$set.ext_rep_id];
            } else {
              alerts.push({
                code: 'distributor-rep-ext-id-invalid',
                level: 'warning',
              });
            }
            newObject.$set.alerts = alerts;

            if (
              newObject.$set.ext_salon_id in queryBuilderCache.salons &&
              newObject.$set.ext_rep_id in queryBuilderCache.reps
            ) {
              salonBulkOps.push({
                updateOne: {
                  filter: {
                    _id: queryBuilderCache.salons[newObject.$set.ext_salon_id],
                    ref: {
                      $elemMatch: {
                        distributor: newObject.$set.distributor,
                        ext_id: obj.$set.ext_salon_id,
                        $or: [
                          { last_sale: { $gt: newObject.$set.date } },
                          { last_sale: { $exists: false } },
                        ],
                      },
                    },
                  },
                  update: {
                    $set: {
                      'ref.$.dsc':
                        queryBuilderCache.reps[newObject.$set.ext_rep_id],
                      'ref.$.last_sale': newObject.$set.date,
                    },
                  },
                },
              });
            }
            return newObject;
          });
          if (salonBulkOps.length > 0) {
            salonMapper.bulkWrite(salonBulkOps).then(res => {
              // do nothing
            });
          }
          return resolve({ chunk: newChunk });
        });
    }),
};



// WEBPACK FOOTER //
// ./src/configs/etl/sales/salesPayloadTransform.js